import { API } from 'aws-amplify';

export const getDashboard = async () => {
  const dashboard = await API.get('deltaSnp-api', `dashboard`);
  return dashboard;
};
